import * as React from "react";
import equal from "fast-deep-equal";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { SelectorContainer } from "../../containers/common/selector";
import { ICategory } from "../../services/api/category-list";
import {
  actionCreators as categoriesActions,
  fetchCategoryList,
} from "../../store/categories/actions";
import { IRootState } from "../../store/index";
import { actionCreators as therapistsActions } from "../../store/therapists/actions";

interface IProps {
  onClick(): void;
  trackChange(value: string | undefined): void;
}

interface IReduxProps {
  categories: ICategory[];
  isCategoriesLoading: boolean;
  selectedCategory?: ICategory;
}

type RouteProps = RouteComponentProps<{ categoryName: string }>;
type Props = IProps & IReduxProps & RouteProps & { dispatch: Dispatch<any> };

class SearchCategoryContainer extends React.Component<Props> {
  public componentDidMount = async () => {
    await this.getCategories();
  };

  private async getCategories() {
    if (!this.props.categories.length && !this.props.isCategoriesLoading) {
      await this.props.dispatch(fetchCategoryList());
    }
  }

  public selectTreatment = async (category: ICategory) => {
    if (!equal(this.props.selectedCategory, category)) {
      // tslint:disable-next-line: await-promise
      await this.props.dispatch(therapistsActions.clearDate());
    }

    this.props.dispatch(categoriesActions.setCategory(category));
  };

  /**
   * Render categories selector
   */
  public render() {
    const selectedCategoryName = this.props.selectedCategory
      ? this.props.selectedCategory.name
      : undefined;

    return (
      <SelectorContainer
        itemKey="id"
        itemName="name"
        items={this.props.categories}
        placeholder="Choose treatment"
        selectedItem={selectedCategoryName}
        onSelect={this.selectTreatment}
        onClick={this.props.onClick}
        trackChange={this.props.trackChange}
      />
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    categories: state.categoriesState.categories,
    isCategoriesLoading: state.categoriesState.isCategoriesLoading,
    selectedCategory: state.categoriesState.selectedCategory,
  };
};

const store = withRouter(
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(
    SearchCategoryContainer,
  ),
);

export { store as SearchCategoryContainer };
